import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import logo from '../assets/Icons/baystream.png';
import { useActions } from '../redux/Actions';
import { selectUserData } from '../redux/auth/auth.selector';
import { selectIsProfileMenuOpen } from '../redux/common/common.selector';
import '../styles/NavigationBar.scss';
import NavHeader from './ui/NavHeader';

const NavigationBar = () => {
  const { Username } = useSelector(selectUserData);
  const isProfileMenuOpen = useSelector(selectIsProfileMenuOpen);

  let loggedInUser = localStorage.getItem('loggedInUser');

  let fileName = sessionStorage.getItem('fileName');
  let fileTitle = sessionStorage.getItem('fileTitle');
  let fileId = sessionStorage.getItem('fileId');
  let vaultName = sessionStorage.getItem('vaultName');
  let server = sessionStorage.getItem('host');
  let header = server + ' : ' + vaultName + ' - ' + fileTitle;
  if (
    fileName == null ||
    fileName == 'undefined' ||
    fileName == 'null' ||
    fileId == 'null' ||
    fileTitle == 'undefined'
  )
    header = server + ' : ' + vaultName;
  if (vaultName == null) header = '';
  const location = useLocation();
  const { setIsProfileMenuOpen } = useActions();

  // on hover of username, show profile menu
  const handleMouseEnter = () => setIsProfileMenuOpen(true);

  // on mouse leave of username, hide profile menu after 3 seconds
  const handleMouseLeave = () => {
    setTimeout(() => {
      setIsProfileMenuOpen(false);
    }, 3000);
  };

  return (
    <nav className="custom-navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <img
            src={logo}
            height={'30px'}
            width={'30px'}
            className="baystream-logo"
            alt="nav-logo"
          />
          <span className="brand-name">View Maven</span>
        </div>

        <div className="navbar-content">
          <NavHeader activeObject={fileTitle ?? ''} />
          {Username && loggedInUser && (
            <div className="user-profile-container">
              <div
                className="user-profile"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                role="button"
              >
                <span className="username">{Username}</span>
                <svg
                  className={`chevron-icon ${
                    isProfileMenuOpen ? 'rotate-180' : ''
                  }`}
                  strokeLinejoin="round"
                  strokeLinecap="round"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                  height="18"
                  width="18"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 9l6 6 6-6"></path>
                </svg>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default NavigationBar;
